import { BrowserRouter, Route, Switch, useHistory } from "react-router-dom";

import routes from "./routes";

export default function App() {
	return (
		<BrowserRouter>
			<Switch>
				{routes.map((route, key) => {
					return (
						<Route
							key={key}
							path={route.path}
							exact={true}
							component={route.component}
						/>
					);
				})}
				<Route component={() => <h1>Page not Found</h1>} />
			</Switch>
		</BrowserRouter>
	);
}
